import './Checkbox.scss';

/**
 * Renders a checkbox input wrapped in a form-group div.
 * 
 * Props: className, checked, defaultChecked, disabled, id, name, onChange, onClick, required, label, value
 */
const Checkbox = (props) => {

  let checkboxClassName = `checkbox`;
  if (props.className) checkboxClassName += ` ${props.className}`;

  return (
    <div className='form-group'>
      <input
        type="checkbox"
        className={checkboxClassName}
        defaultChecked={props.defaultChecked}
        disabled={props.disabled}
        id={props.id}
        name={props.name}
        onChange={props.onChange}
        onClick={props.onClick}
        required={props.required}
        checked={props.checked}
        value={props.value}
      />
      {props.label && <label className='checkbox__label' htmlFor={props.id}>{props.label}</label>}
    </div>
  )
};

export default Checkbox;